<template src="./RegistrationData.html" />

<script>
import { useStore } from "@/store/store.js"
import { computed } from "vue"
import AppointmentsHistory from "../AppointmentsHistory/AppointmentsHistory.vue";
import ContactHistory from "../ContactHistory/ContactHistory.vue";
import ScheduleHistory from "../ScheduleHistory/ScheduleHistory.vue";
import ReturnHistory from "../ReturnHistory/ReturnHistory.vue";
import SchedulePendency from "../SchedulePendency/SchedulePendency.vue";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
import mixins from "@/Mixins.js";

export default {
  mixins: [mixins],
  name: "registration-data",
  components: {
    AppointmentsHistory,
    ContactHistory,
    ScheduleHistory,
    ReturnHistory,
    SchedulePendency,
    WholeMultiselect
  },
  props: ["medicalRecordId"],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showTabs: true,
      genderOptions: [
        { text: "Feminino", value: "FEMALE" },
        { text: "Masculino", value: "MALE" }
      ],
      page: 0,
      genderPatient: "",
      titleCard: "",
      subtitleCard: "",
      maritalStatus: [],
      maritalStatusPatient: "",
      educationalAttainmentsPatient: "",
      educationalAttainments: [],
      address: {
        id: "",
        zipcode: "",
        city: "",
        complement: "",
        neighborhood: "",
        state: "",
        street: "",
        number: ""
      },
      firstAppointmentDateUsFormat: "",
      answer: [
        { text: "Sim", value: true },
        { text: "Não", value: false }
      ],
      hospitalizations: [],
      previousDiseases: [],
      surgeries: [],
      oscs:[],
      idPatient: 0,
      continuousMedicationUse: [],
      cancerHistory: [],
      blockFields: true,
      dataEntered: [],
      smoking: null,
      showPatientData: true,
      showPatientAttendance: false,
      showAppointmentHistory: false,
      showScheduleHistory: false,
      showContactHistory: false,
      showReturnHistory: false,
      showSchedulePendency: false,
      height: null,
      weight: null,
      arterialPressure: null,
      abdominalCircumference: null,
      glycemia: null,
      alcoholism: null,
      drugs: null,
      quantitySmoking: null,
      physicalActivity: null,
      someoneSystemicArterialHypertension: null,
      someoneAcuteMyocardialInfarction: null,
      someoneDementiaSyndrome: null,
      someoneDiabetesMelitus: null,
      someoneStroke: null,
      someoneDepression: null,
      canEdit: null,
      bearerDefault: "",
      osc: null,
    };
  },
  computed: {
    customerId() {
      return this.$route.params.id      
    },
    isProject() {
      return !!this.$session.get("isProject")
    },
  },
  setup () {
    const store = useStore()

    return {
      serverUrl: computed(() => store.state.filooServer),
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  created() {
    this.bearerDefault = this.$session.get("bearerDefault")
    this.addHospitalization()
    this.addPreviusDiase()
    this.addSurgery()
    this.addCancerHistory()
    this.addContinuousMedicationUse()
    this.getRegistrationData()
    this.getMaritalStatus()
    this.getEducationalAttaiments()
    this.getHealthData()
    if (this.isProject) {
      this.getOSCs()
    }
    if (this.$route.params.fc) {
      this.subtitleCard = "Cartão Filóo: " + this.$route.params.fc.replace(/(\d{3})/g, "$1 ")
    }
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    getOSCs() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer +"clinic-project/project-osc")
        .then(function(response) {
          if (response.status === 200) {
            vm.oscs = response.data;
          }
        })
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      vm.showTabs = !(vm.window.width < 420);
    },
    goToRegistrationData() {
      const vm = this;
      vm.page = 0;
      vm.showPatientData = true;
      vm.showAppointmentHistory = false;
      vm.showContactHistory = false;
      vm.showScheduleHistory = false;
      vm.showReturnHistory = false;
      vm.showSchedulePendency = false;
    },
    goToAppointmentHistory() {
      const vm = this;
      vm.page = 2;
      vm.showPatientData = false;
      vm.showAppointmentHistory = true;
      vm.showContactHistory = false;
      vm.showScheduleHistory = false;
      vm.showReturnHistory = false;
      vm.showSchedulePendency = false;
    },
    goToContactHistory() {
      const vm = this;
      vm.page = 3;
      vm.showPatientData = false;
      vm.showAppointmentHistory = false;
      vm.showContactHistory = true;
      vm.showScheduleHistory = false;
      vm.showReturnHistory = false;
      vm.showSchedulePendency = false;
    },
    goToReturnHistory() {
      const vm = this;
      vm.page = 5;
      vm.showPatientData = false;
      vm.showAppointmentHistory = false;
      vm.showContactHistory = false;
      vm.showScheduleHistory = false;
      vm.showReturnHistory = true;
      vm.showSchedulePendency = false;
    },
    goToScheduleHistory() {
      const vm = this;
      vm.page = 4;
      vm.showPatientData = false;
      vm.showAppointmentHistory = false;
      vm.showContactHistory = false;
      vm.showScheduleHistory = true;
      vm.showReturnHistory = false;
      vm.showSchedulePendency = false;
    },
    goToSchedulePendency() {
      const vm = this;
      vm.page = 1;
      vm.showPatientData = false;
      vm.showAppointmentHistory = false;
      vm.showContactHistory = false;
      vm.showScheduleHistory = false;
      vm.showReturnHistory = false;
      vm.showSchedulePendency = true;
    },
    goBackPage() {
      window.history.back();
    },
    showPagePatientData() {
      const vm = this;
      vm.showPatientAttendance = false;
      vm.showPatientData = true;
      vm.showAppointmentHistory = false;
      vm.page = 0;
      window.scrollTo(50, 50);
    },
    addHospitalization() {
      const vm = this;
      vm.hospitalizations.push("");
    },
    removeHospitalization(index) {
      const vm = this;
      vm.hospitalizations.splice(index, 1);
    },
    addPreviusDiase() {
      const vm = this;
      vm.previousDiseases.push("");
    },
    removePreviusDiase(index) {
      const vm = this;
      vm.previousDiseases.splice(index, 1);
    },
    addSurgery() {
      const vm = this;
      vm.surgeries.push("");
    },
    removeSurgery(index) {
      const vm = this;
      vm.surgeries.splice(index, 1);
    },
    addContinuousMedicationUse() {
      const vm = this;
      vm.continuousMedicationUse.push("");
    },
    removeContinuousMedicationUse(index) {
      const vm = this;
      vm.continuousMedicationUse.splice(index, 1);
    },
    addCancerHistory() {
      const vm = this;
      vm.cancerHistory.push("");
    },
    removeCancerHistory(index) {
      const vm = this;
      vm.cancerHistory.splice(index, 1);
    },
    getHealthData() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            vm.$route.params.id +
            "/health-data",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.fillPersonalbackground(response.data);
            vm.fillFamilyHistory(response.data);
            vm.smoking = vm.answer.find(a => {
              return a.value === response.data.smoking;
            });
            vm.height = response.data.height;
            vm.weight = response.data.weight;
            vm.arterialPressure = response.data.arterialPressure;
            vm.abdominalCircumference = response.data.abdominalCircumference;
            vm.glycemia = response.data.glycemia;
            vm.alcoholism = vm.answer.find(a => {
              return a.value === response.data.alcoholism;
            });
            vm.drugs = vm.answer.find(a => {
              return a.value === response.data.drugs;
            });
            vm.physicalActivity = vm.answer.find(a => {
              return a.value === response.data.physicalActivity;
            });
            vm.quantitySmoking = response.data.quantitySmoking;
            vm.someoneSystemicArterialHypertension = vm.answer.find(a => {
              return a.value === response.data.has;
            });
            vm.someoneAcuteMyocardialInfarction = vm.answer.find(a => {
              return a.value === response.data.iam;
            });
            vm.someoneDementiaSyndrome = vm.answer.find(a => {
              return a.value === response.data.sd;
            });
            vm.someoneDiabetesMelitus = vm.answer.find(a => {
              return a.value === response.data.dm;
            });
            vm.someoneStroke = vm.answer.find(a => {
              return a.value === response.data.avc;
            });
            vm.someoneDepression = vm.answer.find(a => {
              return a.value === response.data.dp;
            });
            vm.canEdit = response.data.canEdit;
          }
        });
    },
    fillPersonalbackground(response) {
      const vm = this;
      var index = 0;
      if (response.surgeries.length >= 1) {
        for (index = 0; index < response.surgeries.length; index++) {
          vm.surgeries[index] = response.surgeries[index];
        }
      }

      if (response.hospitalizations.length >= 1) {
        for (index = 0; index < response.hospitalizations.length; index++) {
          vm.hospitalizations[index] = response.hospitalizations[index];
        }
      }

      if (response.previousDiseases.length >= 1) {
        for (index = 0; index < response.previousDiseases.length; index++) {
          vm.previousDiseases[index] = response.previousDiseases[index];
        }
      }

      if (response.continuousMedications.length >= 1) {
        for (
          index = 0;
          index < response.continuousMedications.length;
          index++
        ) {
          vm.continuousMedicationUse[index] =
            response.continuousMedications[index];
        }
      }
    },
    fillFamilyHistory(response) {
      const vm = this;
      var index = 0;
      if (response.cancer.length > 1) {
        for (index = 0; index < response.cancer.length; index++) {
          vm.cancerHistory[index] = response.cancer[index];
        }
      }
      vm.cancerHistory.filter(c => c);
    },
    getRegistrationData() {
      this.axios.get(
        `${this.serverUrl}consultant/patients/${this.customerId}/registration-data`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.dataEntered = data
            this.titleCard = data.patientName
            this.idPatient = data.patientId            
            this.osc = this.dataEntered.osc
            this.genderPatient = this.genderOptions.find(g => g.value === data.gender)

            if (data.address) {
              this.address = data.address
            }

            this.maritalStatusPatient = data.maritalStatus
              ? this.dataEntered.maritalStatus
              : ({ description: "", id: "" })

            this.educationalAttainmentsPatient = this.dataEntered.educationalAttainment
              ? this.dataEntered.educationalAttainment
              : ({ description: "", id: "" })

            if(this.dataEntered.firstAppointment) {
              this.firstAppointmentDateUsFormat = this.dateFormatted(
                this.dataEntered.firstAppointment
              )
            }
          }
        });
    },
    dateFormatted(date) {
      var day = date.split("/")[0];
      var month = date.split("/")[1];
      var year = date.split("/")[2];

      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    getMaritalStatus() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "patient/marital-status", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.maritalStatus = response.data;
          }
        });
    },
    getEducationalAttaiments() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "patient/educational-attainments", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.educationalAttainments = response.data;
          }
        });
    },
    async getAdressData() {
      const response = await this.getAddressByZipcode(this.address.zipcode)

      if (response && response.address) {
        this.address = response.address
      }
    },
    saveHealthData() {
      const vm = this;
      const [ cleanArrayCancerHistory, cleanArrayHospitalizations, cleanArraySurgeries,
        cleanArrayPreviousDiases, cleanArrayContinuousMedicationUse ] = vm.clearHealthData();
      var healthData = {
        address: vm.address,
        age: vm.dataEntered.age != "0" ? vm.dataEntered.age : "",
        cnpj: vm.dataEntered.cnpj,
        companyName: vm.dataEntered.companyName,
        contactCellPhone: vm.dataEntered.contactCellPhone,
        contactEmail: vm.dataEntered.contactEmail,
        contactWhatsApp: vm.dataEntered.contactWhatsApp,
        cpf: vm.dataEntered.cpf,
        dateBirth: vm.dataEntered.dateBirth,
        educationalAttainment: vm.educationalAttainmentsPatient.id === "" ? null : vm.educationalAttainmentsPatient ,
        email: vm.dataEntered.email,
        gender: vm.testNullUndefinedEmpty(vm.genderPatient) ? null : vm.genderPatient.value,
        indication: vm.dataEntered.indication,
        maritalStatus: vm.maritalStatusPatient.id === "" ? null : vm.maritalStatusPatient,
        meansProfissionalContact: vm.dataEntered.meansProfissionalContact,
        naturalness: vm.dataEntered.naturalness,
        acceptJanssenProgram: vm.dataEntered.acceptJanssenProgram,
        notifyByEmail: vm.dataEntered.notifyByEmail,
        notifyByFlyer: vm.dataEntered.notifyByFlyer,
        notifyByPhone: vm.dataEntered.notifyByPhone,
        notifyBySMS: vm.dataEntered.notifyBySMS,
        occupation: vm.dataEntered.occupation,
        patientId: vm.dataEntered.patientId,
        patientName: vm.dataEntered.patientName,
        phone: vm.dataEntered.phone,
        preferenceHistoric: vm.dataEntered.preferenceHistoric,
        religion: vm.dataEntered.religion,
        resideWith: vm.dataEntered.resideWith,
        abdominalCircumference: vm.abdominalCircumference,
        alcoholism: vm.testNullUndefinedEmpty(vm.alcoholism) ? null : vm.alcoholism.value,
        arterialPressure: vm.arterialPressure,
        avc: vm.testNullUndefinedEmpty(vm.someoneStroke) ? null : vm.someoneStroke.value,
        bloodTransfusions: [],
        canEdit: vm.dataEntered.canEdit,
        cancer: cleanArrayCancerHistory,
        continuousMedications: cleanArrayContinuousMedicationUse,
        dm: vm.testNullUndefinedEmpty(vm.someoneDiabetesMelitus) ? null : vm.someoneDiabetesMelitus.value,
        dp: vm.testNullUndefinedEmpty(vm.someoneDepression) ? null : vm.someoneDepression.value,
        drugs: vm.testNullUndefinedEmpty(vm.drugs) ? null : vm.drugs.value,
        glycemia: vm.glycemia,
        has: vm.testNullUndefinedEmpty(vm.someoneSystemicArterialHypertension) ? null : vm.someoneSystemicArterialHypertension.value,
        height: vm.height,
        hospitalizations: cleanArrayHospitalizations,
        iam: vm.testNullUndefinedEmpty(vm.someoneAcuteMyocardialInfarction) ? null : vm.someoneAcuteMyocardialInfarction.value,
        physicalActivity: vm.testNullUndefinedEmpty(vm.physicalActivity) ? null : vm.physicalActivity.value,
        previousDiseases: cleanArrayPreviousDiases,
        quantitySmoking: vm.quantitySmoking,
        sd: vm.testNullUndefinedEmpty(vm.someoneDementiaSyndrome) ? null : vm.someoneDementiaSyndrome.value,
        smoking: vm.testNullUndefinedEmpty(vm.smoking) ? null : vm.smoking.value,
        surgeries: cleanArraySurgeries,
        weight: vm.weight
      };
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            vm.$route.params.id +
            "/health-data",
          healthData,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$swal({
              title: "Sucesso!",
              text: "Dados do paciente salvos com sucesso",
              icon: "success"
            }).then(function() {
              vm.getHealthData();
              vm.getRegistrationData();
            });
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
            icon: "error"
          });
        });
    },
    saveRegistrationData() {
      const vm = this;
      const [ cleanArrayCancerHistory, cleanArrayHospitalizations, cleanArraySurgeries,
        cleanArrayPreviousDiases, cleanArrayContinuousMedicationUse ] = vm.clearHealthData();
      var registrationtData = {
        address: vm.address,
        age: vm.dataEntered.age,
        canEdit: true,
        cnpj: vm.dataEntered.cnpj,
        companyName: vm.dataEntered.companyName,
        contactCellPhone: vm.dataEntered.contactCellPhone,
        contactEmail: vm.dataEntered.contactEmail,
        contactWhatsApp: vm.dataEntered.contactWhatsApp,
        cpf: vm.dataEntered.cpf,
        dateBirth: vm.dataEntered.dateBirth,
        educationalAttainment: vm.educationalAttainmentsPatient.id === "" ? null : vm.educationalAttainmentsPatient,
        email: vm.dataEntered.email,
        gender: vm.testNullUndefinedEmpty(vm.genderPatient)? null : vm.genderPatient.value,
        indication: vm.dataEntered.indication,
        maritalStatus: vm.maritalStatusPatient.id === "" ? null : vm.maritalStatusPatient,
        meansProfissionalContact: vm.dataEntered.meansProfissionalContact,
        naturalness: vm.dataEntered.naturalness,
        acceptJanssenProgram: vm.dataEntered.acceptJanssenProgram,
        notifyByWhatsApp: vm.dataEntered.notifyByWhatsApp,
        notifyByEmail: vm.dataEntered.notifyByEmail,
        notifyByFlyer: vm.dataEntered.notifyByFlyer,
        notifyByPhone: vm.dataEntered.notifyByPhone,
        notifyBySMS: vm.dataEntered.notifyBySMS,
        occupation: vm.dataEntered.occupation,
        patientName: vm.dataEntered.patientName,
        phone: vm.dataEntered.phone,
        preferenceHistoric: vm.dataEntered.preferenceHistoric,
        religion: vm.dataEntered.religion,
        resideWith: vm.dataEntered.resideWith,
        abdominalCircumference: vm.abdominalCircumference,
        alcoholism: vm.testNullUndefinedEmpty(vm.alcoholism)? null : vm.alcoholism.value,
        arterialPressure: vm.arterialPressure,
        avc: vm.testNullUndefinedEmpty(vm.someoneStroke)? null : vm.someoneStroke.value,
        bloodTransfusions: [],
        cancer: cleanArrayCancerHistory,
        continuousMedications: cleanArrayContinuousMedicationUse,
        dm: vm.testNullUndefinedEmpty(vm.someoneDiabetesMelitus)? null : vm.someoneDiabetesMelitus.value,
        dp: vm.testNullUndefinedEmpty(vm.someoneDepression)? null : vm.someoneDepression.value,
        drugs: vm.testNullUndefinedEmpty(vm.drugs)? null : vm.drugs.value,
        glycemia: vm.glycemia,
        has: vm.testNullUndefinedEmpty(vm.someoneSystemicArterialHypertension)? null : vm.someoneSystemicArterialHypertension.value,
        height: vm.height,
        hospitalizations: cleanArrayHospitalizations,
        iam: vm.testNullUndefinedEmpty(vm.someoneAcuteMyocardialInfarction)? null : vm.someoneAcuteMyocardialInfarction.value,
        patientId: vm.dataEntered.patientId,
        physicalActivity: vm.testNullUndefinedEmpty(vm.physicalActivity)? null : vm.physicalActivity.value,
        previousDiseases: cleanArrayPreviousDiases,
        quantitySmoking: vm.quantitySmoking,
        sd: vm.testNullUndefinedEmpty(vm.someoneDementiaSyndrome)? null : vm.someoneDementiaSyndrome.value,
        smoking: vm.testNullUndefinedEmpty(vm.smoking)? null : vm.smoking.value,
        surgeries: cleanArraySurgeries,
        weight: vm.weight,
        osc: vm.osc
      };
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            vm.$route.params.id +
            "/registration-data",
          registrationtData,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.saveHealthData();
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
            icon: "error"
          });
        });
    },
    clearHealthData() {
      const vm = this;
      const cleanArrayCancerHistory = vm.cancerHistory.filter(c => c);
      const cleanArrayHospitalizations = vm.hospitalizations.filter(h => h);
      const cleanArraySurgeries = vm.surgeries.filter(s => s);
      const cleanArrayPreviousDiases = vm.previousDiseases.filter(p => p);
      const cleanArrayContinuousMedicationUse = vm.continuousMedicationUse.filter(cm => cm);
      return [ cleanArrayCancerHistory, cleanArrayHospitalizations, cleanArraySurgeries,
        cleanArrayPreviousDiases, cleanArrayContinuousMedicationUse ];
    },
    schedulePatient() {
      let vm = this;
      vm.popupScheduleAppointment = true;
    },

    mapUrlQuiz(url) {
      window.open(url);
    },
    resendEmailAlert() {
      let vm = this;
      vm.showPopupresendWelcome = true;
    },

    resendWelcome() {
      let vm = this;
      vm.axios
        .post(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            vm.dataEntered.patientId +
            "/quiz",
          vm.dataEntered,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.showPopupresendWelcome = false;
            vm.$swal({
              title: "Sucesso!",
              text:
                "Operação realizada com sucesso! O e-mail de boas vindas foi enviado para o paciente.",
              icon: "success"
            }).then(function() {
              vm.getCustomers();
            });
          }
        })
        .catch(function() {
          vm.showPopupresendWelcome = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
            icon: "error"
          });
        });
    },
  }
};
</script>
<style lang="scss" src="./RegistrationData.scss"></style>
